import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'ts-loading-attribute',
    templateUrl: './loading-attribute.component.html',
    styleUrls: ['./loading-attribute.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatTooltipModule]
})
export class LoadingAttributeComponent {
  /**
   * Optional icon class (e.g., 'ri-file-copy-2-line').
   * If not provided, no icon will be displayed.
   */
  @Input() icon?: string;

  /**
   * The value to display. Can be any type (string, number, etc.).
   * While undefined, a loading dots animation will be shown.
   */
  @Input() value: string | number | undefined;

  /**
   * Optional tooltip text to display on hover.
   * Shows after 700ms delay.
   */
  @Input() tooltip?: string;
}
